export const isMps = (rank?: string) => {
  return rank?.includes('SMP')
}
